import axios from '../axios/axios';

export function getTodayTrustApi(params) {
  return axios.post('/content/gettodaytrust', params);
}

export function getWeekTrustApi(params) {
  return axios.post('/content/getweektrust', params);
}
